import type { FC } from 'react';
import { ShieldCheck } from 'lucide-react';

/** Marks a governed pipeline from the installed domain package. */
const GovernedFragmentTag: FC<{ title: string }> = ({ title }) => (
  <span
    data-testid='fragment-governed-badge'
    title={title}
    className='inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-medium shrink-0 border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300'
  >
    <ShieldCheck aria-hidden='true' className='size-3 shrink-0' />
    Governed
  </span>
);

export default GovernedFragmentTag;
